import { getAutoIdAndPrimary } from 'api/project-nodes/types';
import type { DataNodePropertyValue } from 'api/project-nodes/types';

import type { GraphNodeView } from '../types';

/** The minimal shape both `DataNode` (connected) and `DataNodeDetail` (root) satisfy. */
interface DisplayableNode {
  id: string;
  properties: Record<string, DataNodePropertyValue>;
}

/** The node type this instance belongs to — the caller already knows it from the blueprint. */
interface NodeType {
  templateNodeId: string;
  technicalName: string;
  icon: string;
}

/**
 * Resolve a node (from `GetConnectedNodes` or the single-node detail endpoint) into a `GraphNodeView`.
 * Auto-id and primary come straight off the per-property `isAutoId` / `isPrimary` flags (same as the
 * sidebar list); the type fields are the node's blueprint type, which the caller already knows.
 */
export function toGraphNodeView(node: DisplayableNode, type: NodeType): GraphNodeView {
  const { autoId, primary } = getAutoIdAndPrimary(node.properties);
  const toText = (value: unknown) => (value != null && value !== '' ? String(value) : '');

  return {
    nodeId: node.id,
    templateNodeId: type.templateNodeId,
    technicalName: type.technicalName,
    autoId: toText(autoId),
    primary: toText(primary),
    icon: type.icon
  };
}
